(function () {
  if (customElements.get('subscription-selector')) return;

  class SubscriptionSelector extends HTMLElement {
    connectedCallback() {
      const dataNode = this.querySelector('[data-sub-data]');
      if (!dataNode) return;

      try {
        this.data = JSON.parse(dataNode.textContent);
      } catch (e) {
        return;
      }

      this.formId = this.dataset.formId;
      this.plansWrap = this.querySelector('[data-plans]');
      this.typeInputs = this.querySelectorAll('[data-purchase-type]');
      this.planInputs = this.querySelectorAll('[data-plan-input]');

      this.addEventListener('change', this.update.bind(this));

      // The variant picker sets #product-form-<section> [name="id"] and fires a
      // bubbling change event. It may run before or after this element connects,
      // so listen at the document level and filter.
      this.onDocumentChange = this.onDocumentChange.bind(this);
      document.addEventListener('change', this.onDocumentChange);

      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onDocumentChange);
    }

    get form() {
      return document.getElementById(this.formId);
    }

    get variantId() {
      const form = this.form;
      const input = form && form.querySelector('[name="id"]');
      return input && input.value ? String(input.value) : this.dataset.defaultVariant;
    }

    onDocumentChange(event) {
      const target = event.target;
      if (!target || target.name !== 'id') return;
      const form = this.form;
      if (!form || !form.contains(target)) return;
      this.update();
    }

    selectedType() {
      const checked = Array.prototype.find.call(this.typeInputs, (i) => i.checked);
      return checked ? checked.value : 'onetime';
    }

    selectedPlanId() {
      const checked = Array.prototype.find.call(this.planInputs, (i) => i.checked && !i.disabled);
      return checked ? checked.value : null;
    }

    update() {
      const variantId = this.variantId;
      const variant = this.data[variantId];
      const subscribing = this.selectedType() === 'subscribe';

      if (this.plansWrap) this.plansWrap.hidden = !subscribing;

      this.querySelectorAll('[data-option]').forEach((el) => {
        el.classList.toggle('is-selected', (el.dataset.option === 'subscribe') === subscribing);
      });

      // Show the price nodes belonging to the current variant, hide the rest.
      this.querySelectorAll('[data-for-variant]').forEach((el) => {
        el.hidden = el.dataset.forVariant !== variantId;
      });

      if (variant) this.renderPlans(variant, variantId);

      const planId = subscribing ? this.selectedPlanId() : null;
      this.renderDescription(variant, planId);
      this.writeSellingPlan(planId);
    }

    renderPlans(variant, variantId) {
      const badge = this.querySelector('[data-max-save]');
      if (badge) {
        badge.textContent = badge.dataset.maxSave.replace('%s', variant.maxSave);
        badge.hidden = !(variant.maxSave > 0);
      }

      this.planInputs.forEach((input) => {
        const row = input.closest('[data-plan-row]');
        if (!row) return;

        // A plan can be scoped to specific variants, so it may not apply here.
        const available = Object.prototype.hasOwnProperty.call(variant.plans, input.value);
        row.hidden = !available;
        input.disabled = !available;

        const saveEl = row.querySelector('[data-plan-save]');
        if (saveEl) {
          const save = variant.plans[input.value];
          saveEl.textContent = available && save > 0 ? '-' + save + '%' : '';
        }
      });

      // If the checked plan is unavailable for this variant, fall back to the first usable one.
      const checked = Array.prototype.find.call(this.planInputs, (i) => i.checked);
      if (!checked || checked.disabled) {
        const first = Array.prototype.find.call(this.planInputs, (i) => !i.disabled);
        if (first) first.checked = true;
      }
    }

    renderDescription(variant, planId) {
      const el = this.querySelector('[data-plan-desc]');
      if (!el) return;

      const input = planId
        ? Array.prototype.find.call(this.planInputs, (i) => i.value === planId)
        : null;
      const template = input && input.dataset.desc;

      if (!template) {
        el.hidden = true;
        el.textContent = '';
        return;
      }

      const save = variant && variant.plans ? variant.plans[planId] : null;
      el.textContent = template.replace('%s', save == null ? '' : save);
      el.hidden = false;
    }

    writeSellingPlan(planId) {
      const form = this.form;
      if (!form) return;

      let input = form.querySelector('input[name="selling_plan"]');

      if (!planId) {
        if (input) input.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }

      input.value = planId;
    }
  }

  customElements.define('subscription-selector', SubscriptionSelector);
})();
